<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- Header & Actions -->
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "Stock transfer request" | transloco }}</span>
        <h2 class="bb-page-title">{{ "Stock transfer request" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "Stock transfer" | transloco }}</p>
      </div>

      <div class="bb-header-actions">
        <button routerLink="/Stocktransfer" class="bb-btn bb-btn-primary bb-btn-wide">
          {{ "Stock transfer request" | transloco }}
        </button>

        @if(isAdmin || superAdmin){
          <div class="bb-action-dropdown dropdown">
            <button
              class="bb-btn bb-btn-secondary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ "Pospage" | transloco }}
            </button>

            <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
              <li *ngFor="let el of allWareHouses; let i = index">
                <a class="bb-dropdown-item dropdown-item" (click)="applyWareHouse(el.id)">
                  <i class="fa-solid fa-warehouse"></i>
                  {{ el.name }}
                </a>
              </li>
            </ul>
          </div>
        }
      </div>
    </header>

    <!-- Table -->
    <div class="bb-table-card bb-p-16" *ngIf="!noData">
      <div class="bb-table-scroll">
        <table mat-table [dataSource]="dataSource" class="bb-table">

          <!-- ID -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>#</th>

            <td mat-cell *matCellDef="let el">
              <span class="bb-badge bb-badge-soft-blue">
                #{{ el.id }}
              </span>
            </td>
          </ng-container>

          <!-- FROM -->
          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'From Warehouse' | transloco }}
            </th>

            <td mat-cell *matCellDef="let el">
              <strong class="bb-text-navy bb-font-bold">
                {{ el.from_warehouse?.name }}
              </strong>
            </td>
          </ng-container>

          <!-- TO -->
          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'To Warehouse' | transloco }}
            </th>

            <td mat-cell *matCellDef="let el">
              <strong class="bb-text-navy bb-font-bold">
                {{ el.to_warehouse?.name }}
              </strong>
            </td>
          </ng-container>

          <!-- ITEMS -->
          <ng-container matColumnDef="items">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'items' | transloco }}
            </th>

            <td mat-cell *matCellDef="let el">
              <div class="bb-text-stack">
                <div
                  class="bb-inline-flex bb-items-center bb-gap-8 bb-wrap"
                  *ngFor="let item of el.items; let i = index"
                >
                  <span class="bb-badge bb-badge-soft-cyan">
                    {{ i + 1 }}
                  </span>

                  <strong class="bb-text-navy bb-font-bold">
                    {{ item.stock?.name_ar }}
                  </strong>

                  <small class="bb-text-muted bb-font-semibold">
                    ({{ 'quantity' | transloco }}: {{ item.quantity }})
                  </small>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- NOTES -->
          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'note' | transloco }}
            </th>

            <td mat-cell *matCellDef="let el">
              <span class="bb-text-muted bb-font-semibold">
                {{ el.notes || ('not specific' | transloco) }}
              </span>
            </td>
          </ng-container>

          <!-- USER -->
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'created by' | transloco }}
            </th>

            <td mat-cell *matCellDef="let el">
              <strong class="bb-text-navy bb-font-bold">
                {{ el.user?.first_name }} {{ el.user?.last_name }}
              </strong>
            </td>
          </ng-container>

          <!-- DATE -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'created at' | transloco }}
            </th>

            <td mat-cell *matCellDef="let el">
              {{ formatDate(el.created_at) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
      </div>

      <mat-paginator
        class="bb-paginator"
        [length]="total"
        [pageSize]="pageSize"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>
    </div>

    <!-- No Data State -->
    @if (noData) {
      <div class="bb-empty-state bb-text-center">
        <app-nodata></app-nodata>
      </div>
    }

  </div>
</section>